
"use strict";

(function () {
    /**
     * 判断当前环境是否支持 LocalStorage 缓存
     */
    var _supportLocalStorage = function () {
        var test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }();

    /**
     * 判断当前环境是否支持 SessionStorage 缓存
     */
    var _supportSessionStorage = function () {
        var test = 'test';
        try {
            sessionStorage.setItem(test, test);
            sessionStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }();

    module.exports = {

        /**
         * 将数据存入缓存中
         * @public
         * @param  key   {String}  必选，LocalStorage Key
         * @param  value {*}       必选，需要存入的数据
         * @return       {Boolean} 是否存储成功
         */
        set: function set(key, value) {
            if (!key || !value) {
                return false;
            }

            if (_supportLocalStorage) {
                localStorage.setItem(key, value);
            } else if (_supportSessionStorage) {
                sessionStorage.setItem(key, value);
            }

            return true;
        },

        /**
         * 从缓存中取数据
         * @public
         * @param  key {String} 必选，LocalStorage Key
         * @return     {*}      缓存数据，若 key 为空返回 undefined
         */
        get: function get(key) {
            if (!key) {
                return;
            }

            if (_supportLocalStorage) {
                return localStorage.getItem(key);
            } else if (_supportSessionStorage) {
                return sessionStorage.getItem(key);
            }
        },

        /**
         * 从缓存中清除数据
         * @public
         * @param  key {String}  必选，LocalStorage Key
         * @return     {Boolean} 是否清除成功
         */
        remove: function remove(key) {
            if (!key) {
                return false;
            }

            if (_supportLocalStorage) {
                localStorage.removeItem(key);
            } else if (_supportSessionStorage) {
                sessionStorage.removeItem(key);
            }

            return true;
        },

        /**
         * 检测当前环境是否支持缓存，包括 LocalStorage 及 SessionStorage
         * @public
         * @return {Boolean} 是否支持
         */
        isSupport: function isSupport() {
            return _supportLocalStorage || _supportSessionStorage;
        }
    };
})();


/*****************
 ** WEBPACK FOOTER
 ** ./components/pipe/util/localstorage.js
 ** module id = 11
 ** module chunks = 0
 **/